import { takeLatest, put, call } from "redux-saga/effects";
import request from "../../../components/Utils/httpHelper";
import { CORE_API } from "../../../config";
import { HTTP_HEADERS } from "../../../constants";
import { Preloading } from "../../../components/UI/Preloader/action";
import { TAKE_SUPPORT_AUTOMATION_BACKUP } from "../actionTypes";
import { getBackupConfigForTask } from "../constants";
import { extractApiErrorMessage, isNoBackupDataMessage } from "../helper";
import {
  takeSupportAutomationBackupSuccess,
  takeSupportAutomationBackupFailure,
} from "../action";

export function* takeSupportAutomationBackupSaga(action) {
  const { caseId, taskType } = action.payload || {};
  const taskConfig = getBackupConfigForTask(taskType);

  try {
    if (!taskConfig?.backupEndpoint) {
      throw new Error("Invalid task selected for backup");
    }

    const backupResponse = yield call(
      request,
      `${CORE_API}${taskConfig.backupEndpoint}`,
      {
        method: "GET",
        headers: HTTP_HEADERS,
        params: { caseId },
      }
    );

    const backupData = backupResponse?.data || {};
    const backupFileName = backupData.fileName || null;

    if (!backupData.s3Bucket || !backupData.s3Key) {
      yield put(
        takeSupportAutomationBackupFailure({
          taskType,
          message: "Backup was not stored on S3",
          status: "FAILURE",
        })
      );
      return;
    }

    yield put(
      takeSupportAutomationBackupSuccess({
        taskType,
        backupFileName,
      })
    );
  } catch (err) {
    const message = extractApiErrorMessage(err, "Failed to take backup");
    yield put(
      takeSupportAutomationBackupFailure({
        taskType,
        message,
        noBackupData: isNoBackupDataMessage(message),
        status: "FAILURE",
      })
    );
  } finally {
    yield put(Preloading(false));
  }
}

export function* watchTakeSupportAutomationBackup() {
  yield takeLatest(
    TAKE_SUPPORT_AUTOMATION_BACKUP,
    takeSupportAutomationBackupSaga
  );
}
